<div class="statement" infiniteScroll [infiniteScrollDistance]="page" [infiniteScrollThrottle]="pageSize"
    (scrolled)="onScroll()" [scrollWindow]="false">
    <ul class="list-unstyled">
        <li *ngFor="let statement of statementList; let index = i"
            [style.background-color]="statement.amount > 0 ? '#D9EEE7':'#F9DAD9'">
            <div class="d-flex">
                <img *ngIf="statement.amount < 0" src="assets/img/down arrow.svg" alt="">
                <img *ngIf="statement.amount > 0" src="assets/img/up arrow.svg" alt="">
                <div [style.color]="statement.amount > 0 ? '#008A60':'#D30700'" style="text-align: right;">
                    <span class="desc">مبلغ {{statement.absAmount | persianCurrency: 'slash'}} ریال -
                        {{statement.desc}}</span>
                    <span class="date">{{statement.transactionTime | jalaliConvertor}}</span>
                </div>
            </div>
        </li>
    </ul>
    <div class="bt-spinner-container">
        <div *ngIf="pageLoading" class="bt-spinner"></div>
    </div>
</div>